// extracted by mini-css-extract-plugin
module.exports = {"endOfResults":"search_end_results_message-module__endOfResults--3AESj"};